// Plain code-unit order: fast on 240,000 rows and the same on every machine.
export const compareText = (first: string, second: string): number =>
  first < second ? -1 : first > second ? 1 : 0
